/* eslint-disable no-nested-ternary */
/* eslint-disable no-else-return */
/* eslint-disable no-lonely-if */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import { Controller } from "react-hook-form";
import {
    Autocomplete,
    TextField,
    Checkbox,
    List,
    ListItem,
    Divider,
    Tooltip,
} from "@mui/material";
import { useState, useEffect, useRef } from "react";

const custom = ({
    handleSelectAction,
    field,
    inputValue,
    isAllFilteredSelected,
    isAllSelected,
    getSelectActionLabel,
    ...props
}) => (
    <List {...props} style={{ background: "white", color: "black" }}>
        <ListItem
            onMouseDown={(event) => event.preventDefault()}
            onClick={() => handleSelectAction(field)}
            sx={{
                display: "flex",
                height: "2rem",
                alignItems: "center",
                paddingLeft: "1.9em",
                fontSize: "13px",
            }}
        >
            <Checkbox
                checked={inputValue ? isAllFilteredSelected : isAllSelected}
                style={{ marginRight: 8 }}
                size="small"
            />
            <span style={{ fontSize: "13px" }}> {getSelectActionLabel()} </span>
        </ListItem>
        <Divider />
        {props.children}
    </List>
);


const RHFMultiselectDropdown = ({ formData, control }) => {

    const [inputValue, setInputValue] = useState("");
    const [open, setOpen] = useState(false);
    const frozenOptions = useRef([]);

    const options = formData?.DefaultValues || [];
    const valueExpr = formData?.ValueExpr;
    const displayExpr = formData?.DisplayExpr;

    const rules = formData?.Validations?.reduce((acc, validation) => {
        if (validation.ValidationType === "Required") {
            acc.required = validation.ValidationMessage || "This field is required";
        }
        return acc;
    }, {});

    useEffect(() => {
        setInputValue("");
    }, [control._formValues, valueExpr, options]);

    const computeSortedOptions = (currentSelected) => [
        ...options.filter((o) =>
            currentSelected.some((s) => s[valueExpr] === o[valueExpr])
        ),
        ...options.filter(
            (o) => !currentSelected.some((s) => s[valueExpr] === o[valueExpr])
        ),
    ];

    const getSelectActionLabel = (isAllSelected, isAllFilteredSelected) => {
        if (inputValue) {
            return isAllFilteredSelected
                ? "Unselect Filtered Options"
                : "Select Filtered Options";
        } else {
            return isAllSelected ? "Unselect All" : "Select All";
        }
    };

    return (
        <Controller
            name={valueExpr}
            control={control}
            rules={rules}
            render={({ field, fieldState: { error } }) => {
                const currentSelected = Array.isArray(field.value)
                    ? field.value
                    : field.value
                        ? [field.value]
                        : [];

                const handleOpen = () => {
                    frozenOptions.current = computeSortedOptions(currentSelected);
                    setOpen(true);
                    setInputValue("");
                };

                const handleClose = () => {
                    setOpen(false);
                    setInputValue("");
                };

                const activeOptions = open
                    ? frozenOptions.current
                    : computeSortedOptions(currentSelected);

                const filteredOptions = (inputValue && typeof inputValue === "string")
                    ? activeOptions.filter((option) => {
                        const labelValue = option && displayExpr ? option[displayExpr] : "";
                        return String(labelValue || "")
                            .toLowerCase()
                            .includes(inputValue.toLowerCase());
                    })
                    : activeOptions;

                const isAllSelected =
                    currentSelected.length === options.length && options.length !== 0;

                const isAllFilteredSelected =
                    currentSelected.length > 0 &&
                    filteredOptions.every((option) =>
                        currentSelected.some((s) => s[valueExpr] === option[valueExpr])
                    );

                const handleSelectAction = (f) => {
                    if (inputValue) {
                        if (isAllFilteredSelected) {
                            const updatedOptions = currentSelected.filter(
                                (selected) =>
                                    !filteredOptions.some(
                                        (filtered) =>
                                            filtered[valueExpr] === selected[valueExpr]
                                    )
                            );
                            f.onChange(updatedOptions);
                        } else {
                            const newSelectedOptions = [
                                ...currentSelected,
                                ...filteredOptions.filter(
                                    (filtered) =>
                                        !currentSelected.some(
                                            (selected) =>
                                                selected[valueExpr] === filtered[valueExpr]
                                        )
                                ),
                            ];
                            f.onChange(newSelectedOptions);
                        }
                    } else {
                        if (isAllSelected) {
                            f.onChange([]);
                        } else {
                            f.onChange(options);
                        }
                    }
                };

                return (
                    <Autocomplete
                        {...field}
                        multiple
                        options={activeOptions}
                        value={currentSelected}
                        inputValue={inputValue}
                        open={open}
                        onOpen={handleOpen}
                        onClose={handleClose}
                        onInputChange={(event, newInputValue, reason) => {
                            if (reason !== "reset") {
                                setInputValue(newInputValue || "");
                            }
                        }}
                        getOptionLabel={(option) => (option && displayExpr ? String(option[displayExpr] || "") : "")}
                        isOptionEqualToValue={(option, value) =>
                            option && value && option[valueExpr] === value[valueExpr]
                        }
                        onChange={(event, value, reason) => {
                            if (!(reason === "removeOption" && event.type === "keydown")) {
                                field.onChange(value);
                            }
                        }}
                        disableCloseOnSelect
                        filterOptions={(opts, { inputValue: input }) => {
                            if (!input || typeof input !== "string") return opts;
                            return opts.filter((option) => {
                                const labelValue = option && displayExpr ? option[displayExpr] : "";
                                return String(labelValue || "")
                                    .toLowerCase()
                                    .includes(input.toLowerCase());
                            });
                        }}
                        renderOption={(props, option, { selected }) => (
                            <li
                                {...props}
                                style={{ fontSize: "13px" }}
                                key={option[valueExpr]}
                            >
                                <Checkbox
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                    size="small"
                                />
                                {option[displayExpr]}
                            </li>
                        )}
                        renderTags={(selected) => {
                            const label =
                                selected.length > 0
                                    ? `${selected.length} items selected`
                                    : "";
                            return (
                                <span style={{ fontSize: "13px", paddingLeft: "0.5em" }}>
                                    {label}
                                </span>
                            );
                        }}
                        slots={{
                            paper: custom,
                        }}
                        slotProps={{
                            paper: {
                                handleSelectAction,
                                field,
                                inputValue,
                                isAllFilteredSelected,
                                isAllSelected,
                                getSelectActionLabel: () =>
                                    getSelectActionLabel(isAllSelected, isAllFilteredSelected),
                            },
                        }}
                        PaperComponent={custom}
                        renderInput={(params) => (
                            <Tooltip
                                title={
                                    <div
                                        style={{
                                            maxHeight: "150px",
                                            overflowY:
                                                field?.value != null &&
                                                    field.value?.length > 3
                                                    ? "auto"
                                                    : "hidden",
                                        }}
                                    >
                                        <span
                                            style={{
                                                color: "#9e9e9e",
                                                fontSize: "13px",
                                                fontWeight: "300",
                                            }}
                                        >
                                            {Array.isArray(field?.value) &&
                                                field.value.length > 0 &&
                                                field.value
                                                    .map((item) => item?.[displayExpr])
                                                    .join(", ")}
                                        </span>
                                    </div>
                                }
                                arrow
                                placement="top"
                                PopperProps={{
                                    sx: {
                                        "& .MuiTooltip-tooltip": {
                                            backgroundColor: "white",
                                            color: "black",
                                            border: "1px solid #ccc",
                                            boxShadow:
                                                "0px 2px 8px rgba(0, 0, 0, 0.1), 0px 4px 4px rgba(0, 0, 0, 0.25)",
                                        },
                                        "& .MuiTooltip-arrow": {
                                            color: "white",
                                        },
                                        display:
                                            field.value == null ||
                                                field.value?.length === 0
                                                ? "none"
                                                : "",
                                    },
                                }}
                            >
                                <TextField
                                    {...params}
                                    label={
                                        <>
                                            {formData?.LabelName || displayExpr}
                                            {rules?.required && (
                                                <span
                                                    style={{
                                                        color: "red",
                                                        marginLeft: "2px",
                                                    }}
                                                >
                                                    *
                                                </span>
                                            )}
                                        </>
                                    }
                                    variant="outlined"
                                    size="small"
                                    helperText={
                                        error && (
                                            <span
                                                style={{
                                                    color: "red",
                                                    fontSize: "10px",
                                                }}
                                            >
                                                {error.message}
                                            </span>
                                        )
                                    }
                                    fullWidth
                                    sx={{
                                        "& .MuiInputBase-input": {
                                            fontSize: "13px",
                                        },
                                        "& .MuiFormLabel-root": {
                                            fontSize: "14px",
                                        },
                                        "& .MuiOutlinedInput-root": {
                                            backgroundColor: formData?.emptyFieldBgColor && (field.value == null || field.value?.length === 0) ? formData.emptyFieldBgColor : undefined,
                                        },
                                    }}
                                />
                            </Tooltip>
                        )}
                    />
                );
            }}
        />
    );
};

export default RHFMultiselectDropdown;